
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"32","viewBox":"0 0 32 32","width":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.494 16.803c.604 0 1.12.107 1.547.32.435.204.764.484.987.84s.333.751.333 1.187c0 .418-.084.791-.253 1.12-.16.32-.369.569-.627.747a1.314 1.314 0 01-.773.267v.027c.338 0 .644.084.92.253.284.169.511.409.68.72s.253.671.253 1.08c0 .48-.134.911-.4 1.293s-.644.68-1.133.893c-.48.213-1.036.32-1.667.32-1.591 0-2.644-.711-3.16-2.133l1.307-.627c.134.515.347.902.64 1.16.293.249.716.373 1.267.373.533 0 .951-.129 1.253-.387.302-.267.454-.618.454-1.053 0-.48-.147-.818-.44-1.013-.284-.205-.742-.307-1.373-.307h-.4V20.75h.36c1.102 0 1.653-.453 1.653-1.36 0-.445-.129-.782-.387-1.013-.249-.231-.604-.347-1.067-.347-.471 0-.849.115-1.133.347-.276.222-.454.542-.533.96l-1.307-.533c.186-.64.547-1.133 1.08-1.48.542-.347 1.182-.52 1.92-.52zm8.226.134v8.8h-1.4V19.23c0-.302.004-.538.015-.707a4.744 4.744 0 01-1.04.76 4.349 4.349 0 01-1.173.453l-.267-1.24c.231-.027.529-.125.893-.293.373-.169.724-.369 1.053-.6s.569-.453.72-.667zm1.96-8.835a.64.64 0 01-.64-.64V.64a.638.638 0 011.093-.453.64.64 0 01.187.453v6.822a.638.638 0 01-.64.64zm7.68 3.943H.64a.64.64 0 110-1.28h30.72a.64.64 0 110 1.28zM29.734 32H2.291a2.265 2.265 0 01-2.266-2.266V5.683a2.261 2.261 0 01.663-1.602 2.265 2.265 0 011.602-.664h27.443a2.252 2.252 0 012.093 1.398c.114.275.172.569.172.867v24.051a2.265 2.265 0 01-2.266 2.266zM2.291 4.698a.985.985 0 00-.986.986v24.051a.997.997 0 00.985.985h27.443a.985.985 0 00.986-.986V5.683c.002-.13-.02-.259-.072-.379s-.121-.23-.213-.322a.968.968 0 00-.701-.285zM8.32 8.102a.64.64 0 01-.64-.64V.64A.638.638 0 018.773.187.64.64 0 018.96.64v6.822a.638.638 0 01-.64.64z"}})])
          )
        }
      }
    